import { render } from "./SupervisorStaffTab.vue?vue&type=template&id=1031e1d9"
import script from "./SupervisorStaffTab.vue?vue&type=script&lang=js"
export * from "./SupervisorStaffTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__